<template>
    <div v-loading="!finishGetList">
        <item-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :categoryData="categoryData"
                          :sortData="filterSet.sort" :paginationData="filterSet.page"></item-filter-link>
        <item-list-link :listLayout="listLayout" :itemData="List" :paginationData="filterSet.page"
                        :sortData="filterSet.sort"></item-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import ItemFilterLink from "@/components/item/link/ItemFilterLink";
import ItemListLink from "@/components/item/link/ItemListLink";
import PaginationLink from "@/components/item/link/PaginationLink";
import itemUtil from "@/components/item/itemUtil.js";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import {elasticOption} from "@/api/config";

const {filterConfig} = itemUtil;
export default {
    name: "ItemListNewComponent",
    mixins: [alertMixins, itemUtil, filterMixins, listMixins],
    components: {ItemFilterLink, ItemListLink, PaginationLink},
    inject: [],
    provide() {
        return {
            resetFilter: this.resetFilter,
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
            itemConnect:this.itemConnect,
            itemDisConnect:this.itemDisConnect,
            itemListSetData: this.setData,
        }
    },
    props: {
        itemType: '',
        brandKey:{default: () => 0},
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
            getFunc: '',

            getCategoryFunc: '',
            isCategory: false,
            categoryData: [],
            categoryApiParamSet: {},
            keyName: '',
            directUrl: '',
            directType: '',

        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        if (this.isGetFirst) {
            this.getList(true);
        } else {
            this.finishGetList = true;
        }
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let config = this.returnItemConfig(this.itemType);
            this.filterLayout = config.filterLayout;
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;
            this.categoryApiParamSet = config.categoryApiParamSet;

            this.keyName = config.keyName
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let defaultParams = Object.assign({}, this.listApiParamSet);
            if(this.brandKey != 0){
                defaultParams.bid = this.brandKey;
            }

            let listOptions = {
                url: this.$api.$item[this.getFunc],
                defaultParams: defaultParams,
            }

            this.initList('api', listOptions);

            if (this.isCategory) {
                this.getCategory();
            }
        },
        itemConnect(items){
            let params = {
                i_idx:[],
                b_idx: this.brandKey,
            };
            util.Array.each(items, (data, index, arr) => {
                params.i_idx.push(data.i_idx);
            })
            try {
                this.$api.$brand.brandConnect(params).then(res => res.Data.Result).then(res => {
                    let alertContent='';
                    if (res.Info.Type === 1) {
                        alertContent = `연결 되었습니다.`;
                    } else {
                        alertContent = '연결에 실패하였습니다.'
                    }
                    this.runElasticIndexing(params.i_idx, 0).then(res => {
                        this.updateFinishAlert(alertContent);
                    })
                })
            } catch (e) {
                console.log(e);
            }
        },
        itemDisConnect(){
            let selected = this.selectRow.slice();
            if(selected.length < 1) {
                this.errorAlert('1개 이상 선택해주세요.')
                return false;
            }
            this.tableLoading = true;
            let params = {i_idx:[]};
            util.Array.each(selected, (data, index, arr) => {
                params.i_idx.push(data.i_idx);
            })
            try {
                this.$api.$brand.brandDisconnect(params).then(res => res.Data.Result).then(res => {
                    let alertContent='';
                    if (res.Info.Type === 1) {
                        alertContent = `연결 해제되었습니다.`;
                    } else {
                        alertContent = '연결 해제에 실패하였습니다.'
                    }
                    this.runElasticIndexing(params.i_idx, 0).then(res => {
                        this.updateFinishAlert(alertContent);
                    })
                })
            } catch (e) {
                console.log(e);
            }
        },
        updateFinishAlert(content) {
            this.createAlert({
                title: '',
                content: content,
                btnText: "확인",
                hide: () => {
                    this.getList();
                }
            });
        },
        runElasticIndexing(arr, index) {
            let key = arr[index];
            let param = {
                i_idx : key,
                index : elasticOption.index
            }
            return this.$api.$item.indexingItem(param).then(res => {
                if(arr.length-1 == index) {
                    return true;
                }else {
                    this.runElasticIndexing(arr, index+1);
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
